module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3r4r8r-7f9dcb8aec77f7944cf722869df4d3af.svg";